import { createFileRoute } from '@tanstack/react-router'
import { getPlanSummary } from '@rpc/plans.rpc'
import { getSubscriptionStatus } from '@rpc/billing.rpc'
import { DashboardContent } from '@/components/dashboard-home-content'

export const Route = createFileRoute('/dashboard/home')({
  loader: async () => {
    const subscription = await getSubscriptionStatus()
    if (!subscription.hasSubscription || !subscription.planId) {
      return { subscription, subscriptionPlan: null }
    }

    const subscriptionPlan = await getPlanSummary({
      data: { planId: subscription.planId },
    })
    return { subscription, subscriptionPlan }
  },
  component: DashboardIndex,
})

function DashboardIndex() {
  const context = Route.useRouteContext({ select: (ctx) => ctx })
  const { session } = context as any
  const { subscription, subscriptionPlan } = Route.useLoaderData()
  return (
    <DashboardContent
      session={session}
      subscription={subscription}
      subscriptionPlan={subscriptionPlan}
    />
  )
}
